import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { vehicleNumberDisplay } from '../../../../utils/utils';
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    height: 84,
    padding: "16px 24px",
    display: 'flex',
    alignItems: 'center',
    backgroundColor:'#fff'
  },
  icon:{
    fontSize:52,
    color:'#000'
  },
  info:{
    marginLeft:24,
  },
  infoAction:{
    marginTop:8,
    display:'flex',
    alignItems:'center',
    color:'#03c',
    fontSize:14,
    cursor:'pointer',
  },
  vehicleNumber:{
      color:'#0b1323',
      fontWeight:600,
      fontSize:18,
      margin:0,
      display:'flex',
      alignItems:'center'
  },
  noMargin:{
      margin:0,
      marginBottom:0
  },
  marketTruck: {
    backgroundColor: '#e86825',
    color: 'white',
    fontSize: 10,
    fontWeight: 'bold',
    paddingLeft: 6,
    paddingRight: 6,
    borderRadius: 4,
    paddingTop: 3,
    paddingBottom: 3,
    letterSpacing: '1px',
    marginLeft: 16
  }
}));
const JourneyTruckCard = (props) => {
  const {vehicle} = props;
  const classes = useStyles();
  let history = useHistory();
  const goToVehicleView = () => {
    if (vehicle && vehicle.vehicleId && !vehicle.isVehicleDeleted) {
      const vehicleId = vehicle.vehicleId;
      const vehicleNumberPreffix = vehicle.vehicleNumberPrefix;
      const vehicleNumberSuffix = vehicle.vehicleNumberSuffix;
      const status = vehicle.status ? vehicle.status : '';
      history.push({
        pathname: `/trucks/single-truck/${vehicleId}`,
        state: {
          id: 8,
          vehicleStatus: status || null,
          pageTitle: [vehicleNumberPreffix, vehicleNumberSuffix],
          vehicleId: vehicleId,
          ownershipType: vehicle.ownershipType?vehicle.ownershipType:'',
          bodyType:  vehicle.vehicleBodyType?vehicle.vehicleBodyType:''
        }
      });
    }
  }
  return (
    <>
      <Paper component='div' className={classes.card} >
          <LocalShippingIcon className={classes.icon} />
          <div className={classes.info}>
            <Typography className={classes.vehicleNumber}>{vehicle&&vehicle.vehicleNumber?vehicleNumberDisplay(vehicle.vehicleNumber):''}{vehicle&&vehicle.ownershipType&& vehicle.ownershipType=='HIRED'?<span className={classes.marketTruck}>MARKET</span>:null}</Typography>
            <div className={classes.infoAction} onClick={goToVehicleView}>
                <Typography className={classes.noMargin}>View Truck</Typography>
                <ChevronRightIcon />
            </div>
          </div>
      </Paper>
    </>
  );
}
export default JourneyTruckCard;